import { c as _c } from "react/compiler-runtime";
import type { MetadataValueLengthStatus } from "../utils/submissionMetadata";
interface MetadataLengthHintProps {
  readonly status?: MetadataValueLengthStatus | undefined;
  readonly className?: string | undefined;
}
export default function MetadataLengthHint(t0) {
  const $ = _c(11);
  const {
    status,
    className
  } = t0;
  if (!status || !status.isWarning && !status.isError) {
    return null;
  }
  const baseClassName = `tw-text-xs ${className ?? ""}`;
  if (status.isError) {
    const t1 = `tw-text-red ${baseClassName}`;
    const t2 = status.length;
    const t3 = status.maxLength;
    let t4;
    if ($[0] !== status.remaining) {
      t4 = Math.abs(status.remaining);
      $[0] = status.remaining;
      $[1] = t4;
    } else {
      t4 = $[1];
    }
    let t5;
    if ($[2] !== status.length || $[3] !== status.maxLength || $[4] !== t1 || $[5] !== t4) {
      t5 = <p role="alert" aria-live="polite" className={t1}>{t2}/{t3} characters.{" "}{t4} over limit.</p>;
      $[2] = status.length;
      $[3] = status.maxLength;
      $[4] = t1;
      $[5] = t4;
      $[6] = t5;
    } else {
      t5 = $[6];
    }
    return t5;
  }
  const t1 = `tw-text-amber-400 ${baseClassName}`;
  let t2;
  if ($[7] !== status.length || $[8] !== status.maxLength || $[9] !== t1) {
    t2 = <p className={t1}>{status.length}/{status.maxLength} characters.</p>;
    $[7] = status.length;
    $[8] = status.maxLength;
    $[9] = t1;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  return t2;
}